var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ffffff",
    d: "M63.712,13.29L55.28,53.896C54.364,58.397,51.322,60,48.779,60 c-1.312,0-2.674-0.393-4.052-1.171l-0.229-0.131l-0.214-0.16L26.75,45.302l-0.659,7.735c-0.344,1.807-1.988,3.105-3.859,2.951 c-1.438-0.119-2.604-1.06-3.091-2.32l-2.926-8.785C16.081,44.613,16,44.317,16,44c0-1.105,0.895-2,2-2 c0.873,0,1.605,0.56,1.879,1.338c0.002,0,0.005-0.002,0.007-0.005l2.402,7.215l0.352-4.129c0-0.005,0-0.005,0-0.007 c0.218-2.645,2.538-4.613,5.183-4.396c0.873,0.07,1.666,0.381,2.335,0.847l16.535,12.482c0.77,0.434,1.47,0.654,2.086,0.654 c1.277,0,2.184-0.95,2.581-2.901l8.448-40.682C60.498,9.596,59.249,8,57.568,8c-0.429,0-0.885,0.104-1.348,0.317L6.616,27.864 c-3.387,1.389-3.367,3.318-0.618,4.177l8.199,2.616c0.002,0,0.01-0.005,0.012-0.003c0.562,0.175,1.195,0.114,1.733-0.223 c0.01-0.005,0.017-0.003,0.026-0.008l21.938-13.825c1.859-1.146,4.301-0.591,5.474,1.261c0.997,1.573,0.751,3.571-0.468,4.87 L31.414,38.226v0.002l-0.031,0.029l-0.002-0.002c-0.359,0.344-0.844,0.558-1.379,0.558c-1.105,0-2-0.895-2-2 c0-0.536,0.213-1.021,0.558-1.38l-0.002-0.002l11.394-11.396L18.015,37.859c-1.566,0.95-3.396,1.12-5.023,0.604 c-0.012-0.005-0.024,0-0.037-0.005l-8.15-2.599c-4.295-1.343-4.759-4.456-4.8-5.377c-0.065-1.552,0.506-4.438,5.093-6.32l0.024-0.01 l0.026-0.01l49.515-19.51C55.61,4.213,56.587,4,57.568,4c1.959,0,3.766,0.87,4.958,2.391C63.926,8.17,64.345,10.618,63.712,13.29 L63.712,13.29z M30,50c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2S28.895,50,30,50L30,50z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.60619ada8bec29077f10dec85292fe70.svg";
export { ForwardRef as ReactComponent };